__turbopack_context__.v({
  "outro": "calculatorOutro-module-scss-module__8ip5nq__outro",
  "outroText": "calculatorOutro-module-scss-module__8ip5nq__outroText",
  "title": "calculatorOutro-module-scss-module__8ip5nq__title",
});
